import { EdoQuestionTypeEnum } from "@/shared/model/enumerations/edo-question-type.mode";
import { AlignLeft, CheckSquare, CircleDot, ToggleLeft, Type } from "lucide-react";

export const getQuestionType = (type: EdoQuestionTypeEnum, short: boolean = false) => {
  switch (type) {
    case EdoQuestionTypeEnum.FREE_TEXT:
      return short ? "Risposta scritta" : "Domanda a risposta scritta";
    case EdoQuestionTypeEnum.MULTIPLE_CHOICE:
      return short ? "Risposta multipla" : "Domanda a risposta multipla";
    case EdoQuestionTypeEnum.SINGLE_CHOICE:
      return short ? "Risposta singola" : "Domanda a risposta singola";
    case EdoQuestionTypeEnum.TRUE_FALSE:
      return short ? "Risposta Vero/Falso" : "Domanda Vero/Falso";
    case EdoQuestionTypeEnum.FILL_BLANK:
      return short ? "Risposta a riempimento" : "Domanda a riempimento";
  }
};

export const getQuestionIcon = (type: EdoQuestionTypeEnum) => {
  const iconClass = "h-5 w-5 text-[var(--color-mockup-text-light)]";
  switch (type) {
    case EdoQuestionTypeEnum.SINGLE_CHOICE:
      return <CircleDot className={iconClass} />;
    case EdoQuestionTypeEnum.MULTIPLE_CHOICE:
      return <CheckSquare className={iconClass} />;
    case EdoQuestionTypeEnum.TRUE_FALSE:
      return <ToggleLeft className={iconClass} />;
    case EdoQuestionTypeEnum.FILL_BLANK:
      return <Type className={iconClass} />;
    case EdoQuestionTypeEnum.FREE_TEXT:
      return <AlignLeft className={iconClass} />;
  }
};
